<template>
  <div>
    <div class="flowStatistics">
      <timeChuli class="timeChuli" @btnClick="gailan"></timeChuli>
      <div class="cross">
        <div class="line"></div>
        <div class="info">数据概览</div>
      </div>

      <div class="dataInfo">
        <div class="dataInfo_item" v-for="(item, index) in dataInfo" :key="index">
          <img src="../../assets/img/dataBoard/icon1.png" class="img" alt/>
          <div class="info">
            <div class="info_num">{{item.total}}</div>
            <div class="info_title">{{item.dataName}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="linechart">
      <echarts :option="options"></echarts>
      <div class="cross absolute">
        <div class="line"></div>
        <div class="info">流量趋势</div>
      </div>

      <timeChuli class="timeChuli" :btnList="btnList" @btnClick="liuliang"></timeChuli>
    </div>
  </div>
</template>

<script>
  import timeChuli from "../components/timeChuli";
  import echarts from "../../components/commonComponents/echarts";
  import moment from "moment";
  import GlobalUtil from "@/utils/globalUtil";

  export default {
    components: {
      timeChuli,
      echarts
    },
    data() {
      return {
        dataInfo: [],
        lineEcharts: {},
        btnList: [
          {
            type: "2",
            name: "近一周",
            active: true
          },
          {
            type: "3",
            name: "近一月",
            active: false
          },
          {
            type: "4",
            name: "近一年",
            active: false
          },
          {
            type: "5",
            name: "累计",
            active: false
          }
        ],
        options: {
          tooltip: {
            trigger: "axis"
            // formatter: function(params){
            //   console.log(params)
            //   return ''
            //   // return params[0].marker+'<br/>'+params[0].seriesName+': '+params[0].value+'%'
            // }
          },
          legend: {
            data: ["累计访问量", "累计线索客户", "累计意向客户", "累计成交客户", "累计分享数"],
            right: "350",
            top: "7"
          },
          grid: {
            left: "3%",
            right: "3%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: []
          },
          yAxis: {
            type: "value"
          },
          series: [
            {
              name: "累计访问量",
              type: "line",
              smooth: true,
              itemStyle: {
                normal: {
                  color: '#FB7878', //改变折线点的颜色
                  lineStyle: {
                    color: '#FB7878' //改变折线颜色
                  }
                }
              },
              data: []
            },
            {
              name: "累计线索客户",
              type: "line",
              smooth: true,
              itemStyle: {
                normal: {
                  color: '#01C0C8', //改变折线点的颜色
                  lineStyle: {
                    color: '#01C0C8' //改变折线颜色
                  }
                }
              },
              data: []
            },
            {
              name: "累计意向客户",
              type: "line",
              smooth: true,
              itemStyle: {
                normal: {
                  color: '#FEC107', //改变折线点的颜色
                  lineStyle: {
                    color: '#FEC107' //改变折线颜色
                  }
                }
              },
              data: []
            },
            {
              name: "累计成交客户",
              type: "line",
              smooth: true,
              itemStyle: {
                normal: {
                  color: '#00C292', //改变折线点的颜色
                  lineStyle: {
                    color: '#00C292' //改变折线颜色
                  }
                }
              },
              data: []
            },
            {
              name: "累计分享数",
              type: "line",
              smooth: true,
              itemStyle: {
                normal: {
                  color: '#AB8CE4', //改变折线点的颜色
                  lineStyle: {
                    color: '#AB8CE4' //改变折线颜色
                  }
                }
              },
              data: []
            },
          ]
        },
        timeFlag: "1",
        params: {
          startDate: moment(new Date())
            .subtract(7, "days")
            .format("YYYY-MM-DD"),
          endDate: moment(new Date()).format("YYYY-MM-DD"),
          timeGranularity: "DAY"
        },
        dataList: {
          skim: "累计访问量",
          line: "累计线索客户",
          wish: "累计意向客户",
          trade: "累计客户"
        },
        date: ""
      };
    },
    methods: {
      // 流量趋势日期点击事件
      liuliang(str) {
        switch (str) {
          case "2":
            this.params.startDate = moment(new Date())
              .subtract(7, "days")
              .format("YYYY-MM-DD");
            this.params.timeGranularity = "DAY";
            break;
          case "3":
            this.params.startDate = moment(new Date())
              .subtract(30, "days")
              .format("YYYY-MM-DD");
            this.params.timeGranularity = "DAY";
            break;
          case "4":
            this.params.startDate = moment(new Date())
              .subtract(12, "month")
              .format("YYYY-MM-DD");
            this.params.timeGranularity = "MONTH";
            break;
          case "5":
            this.params.startDate = moment(this.date).format("YYYY-MM-DD");
            this.params.timeGranularity = "MONTH";
            break;
        }
        // if(str == '3'){
        //   this.params.startDate =  moment(new Date()).subtract(30,'days').format("YYYY-MM-DD")
        //   // this.params.endDate =  moment(new Date()).subtract(30,'days').format("YYYY-MM-DD")
        //   this.params.timeGranularity  = 'MONTH'
        // }
        this.timeFlag = str;
        // this.options.legend.data = [];
        // this.options.series = [];
        this.getFlowTrend();
      },
      // 数据概览日期点击事件
      gailan(str) {
        console.log("222", str);
        this.queryEntCustomStatistic(str);
      },
      // 流量趋势
      getFlowTrend() {
        this.$axios.post(this.$url.getFlowTrend, this.params).then(res => {
          if (res) {
            let arr = [];
            for (const key in res.data) {
              arr.push(res.data[key]);
            }
            let timeArr = [];
            for (var i = 0; i <= arr.length; i++) {
              let list = arr[i].map(_ => {
                return _.total;
              });
              timeArr = arr[i].map(_ => {
                return _.bizDate;
              });
              this.options.series[i].data = list;
              this.options.xAxis.data = timeArr;
            }
          }
        });
      },
      // 流量统计
      queryEntCustomStatistic(val) {
        this.$axios
          .get(this.$url.queryEntCustomStatistic, {
            timeFlag: val
          })
          .then(res => {
            console.log("流量统计", res);
            this.dataInfo = res.data;
          });
      },
      getCreateDate() {
        this.$axios
          .get(this.$url.getEntCreateDate, {
            entCode: GlobalUtil.readCookie("entCodeEq")
          })
          .then(res => {
            if (res) {
              this.date = res.data;
            }
          });
      }
    },

    created() {
      this.getCreateDate();
      this.queryEntCustomStatistic("");
      this.getFlowTrend();
    },
    mounted() {
      console.log(this.startDate);
    }
  };
</script>

<style lang='less' scoped>
  .flowStatistics {
    width: 100%;
    padding: 20px;
    margin-bottom: 20px;
    box-sizing: border-box;
    background-color: #fff;
    position: relative;

    .dataInfo {
      display: flex;
      margin-bottom: 10px;
      justify-content: space-between;
    }

    .dataInfo_item {
      display: flex;
      align-items: center;
      height: 72px;
      width: 300px;
      box-sizing: border-box;
      padding: 20px 28px;
      border-radius: 3px;

      .img {
        height: 32px;
        width: 32px;
        margin-right: 20px;
      }

      .info {
        color: rgba(255, 255, 255, 1);

        .info_num {
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 5px;
        }

        .info_title {
          font-size: 14px;
        }
      }
    }

    .dataInfo_item:nth-child(1) {
      background: rgba(251, 120, 120, 1);
    }

    .dataInfo_item:nth-child(2) {
      background: rgba(254, 193, 7, 1);
    }

    .dataInfo_item:nth-child(3) {
      background: rgba(1, 192, 200, 1);
    }

    .dataInfo_item:nth-child(4) {
      background: rgba(0, 194, 146, 1);
    }

    .dataInfo_item:nth-child(5) {
      background: rgba(171, 140, 228, 1);
    }
  }

  .cross {
    display: flex;
    box-sizing: border-box;
    align-items: center;
    margin-bottom: 30px;

    .line {
      width: 3px;
      height: 19px;
      background: rgba(102, 102, 102, 1);
      margin-right: 5px;
    }

    .info {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }
  }

  .timeChuli {
    position: absolute;
    right: 0;
    top: 20px;
    z-index: 9999;
  }

  .linechart {
    height: 626px;
    width: 100%;
    background-color: #fff;
    position: relative;
    padding-top: 20px;
  }

  .absolute {
    position: absolute;
    left: 20px;
    top: 20px;
    z-index: 11111;
  }
</style>
